import { useEffect } from 'react';
import { setPageMeta } from '../utils/seo';
import content from '../content/siteContent.json';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const { privacyPolicy } = content;

  useEffect(() => {
    setPageMeta({
      title: privacyPolicy.meta.title,
      description: privacyPolicy.meta.description,
    });
  }, []);

  return (
    <div className="page privacy-policy-page">
      <section className="grid">
        <div className="section-title">
          <p className="eyebrow">{privacyPolicy.eyebrow}</p>
          <h1>{privacyPolicy.title}</h1>
          <p className="section-lead">{privacyPolicy.lead}</p>
        </div>
        <div className="card">
          <p className="privacy-policy-text">{privacyPolicy.intro}</p>
        </div>
      </section>

      <section className="grid">
        <div className="card-grid">
          {privacyPolicy.sections.map((section) => (
            <article className="card privacy-policy-section" key={section.heading}>
              <h3 className="privacy-policy-heading">{section.heading}</h3>
              {section.paragraphs.map((text) => (
                <p className="privacy-policy-text" key={text}>{text}</p>
              ))}
              {section.items && (
                <ul className="list privacy-policy-list">
                  {section.items.map((item) => (
                    <li key={`${section.heading}-${item.title}`}>
                      <span className="privacy-policy-latin"><strong>{item.title}:</strong></span> <span className="privacy-policy-latin">{item.body}</span>
                    </li>
                  ))}
                </ul>
              )}
              {section.links && (
                <ul className="list privacy-policy-list">
                  {section.links.map((link) => (
                    <li key={link.url}>
                      <a className="privacy-policy-latin" href={link.url} target="_blank" rel="noreferrer">{link.label}</a>
                    </li>
                  ))}
                </ul>
              )}
              {section.footnote && <p className="privacy-policy-text">{section.footnote}</p>}
            </article>
          ))}
        </div>
      </section>

      <section className="grid">
        <div className="card highlight">
          <p className="eyebrow">{privacyPolicy.contact.eyebrow}</p>
          <h2>{privacyPolicy.contact.title}</h2>
          <p className="privacy-policy-text privacy-policy-latin">開発者名：{privacyPolicy.contact.name}</p>
          <p className="privacy-policy-text privacy-policy-latin">
            メールアドレス：
            <a className="footer__link privacy-policy-latin" href={`mailto:${privacyPolicy.contact.email}`}>
              {privacyPolicy.contact.email}
            </a>
          </p>
          <p className="privacy-policy-text">{privacyPolicy.contact.note}</p>
          <p className="privacy-policy-text privacy-policy-latin">{privacyPolicy.contact.enactedOn}</p>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
